module.exports = __webpack_public_path__ + "img/b4d44f4263937d014f12eabe8f80d62a.svg";